import React, { useState, useEffect, useReducer, useContext } from 'react';
import {
  Tooltip,
  Badge,
  Button,
  Tag,
  Steps,
  message,
  Progress,
  Modal
} from 'antd';
import moment from 'moment';
import {
  FormOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import { Table, Page } from '../../components';
import { GoodsSelect, OrderNew, OrderDetail } from '../';
import { getListEnabled as getBuyerList } from '../../services/Buyer';
import { getListEnabled as getSupplierList } from '../../services/Supplier';
import { getListEnabled as getGoodsList } from '../../services/Goods';
import { getListEnabled as getOrderPermissionList } from '../../services/Entity';
import {
  getList as getOrderList,
  getListCount,
  download, downloadPurchase,
  downloadPackage,
  downloadDeliveryPost,
  insert, update,
  insertPermissionByOrderId,
  savePurchaseByOrderId,
  reviewPurchaseSuppliers,
  updateGoodsSplitCount,
  cancelGoodsSplitCount,
  updateGoodsSplitSpec,
  cancelGoodsSplitSpec,
  syncOrderPackages,
  returnOrderPackages,
  terminateById,
  draftById,
  restoreById,
  downloadPalletDetail
} from '../../services/Order';
import { parsePackageList } from '../../utils/Report';
import { MasterContext } from '../../App';
import './style';

const { Step } = Steps;
export const OrderContext = React.createContext(null);

export default React.forwardRef((props, ref) => {
  const { user, currentUser, authorities } = useContext(MasterContext);

  const [isShowNew, setShowNew] = useState(false);
  const [isLoadding, setLoadding] = useState(false);
  const [isShowDetail, setShowDetail] = useState(false);
  const [clickedOrderId, setClickedOrderId] = useState('');
  const [isShowGoodsSelect, setShowGoodsSelect] = useState(false);
  const [keyword, setKeyword] = useState(undefined);

  const onSearch = (keyword) => {
    const temp = (keyword || '').trim();
    if (temp.length === 0) setKeyword(undefined);
    else setKeyword(temp);
  }
  const onSavePermissionCallback = (id, values) => {
    if (values && values.length > 0) {
      try {
        const key = 'update_order_permission';
        console.log('onSavePermissionCallback:', values);
        message.loading({ content: '正在更新订单权限...', key });
        insertPermissionByOrderId(id, values).then(() => {
          message.success({ content: `更新订单权限成功`, key, duration: 2 });
        })
      } catch (errInfo) {
        console.log('Error:', errInfo);
      }

    }
  }

  const onCancelSplitCountCallback = (order_id, pid, callback) => {
    try {
      const key = 'save_order_split';
      console.log('onSaveSplitCallback:', order_id, pid);
      message.loading({ content: '正在更新订单采购信息...', key });
      cancelGoodsSplitCount(order_id, pid).then(() => {
        message.success({ content: `更新订单采购信息成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onCancelSplitSpecCallback = (order_id, pid, callback) => {
    try {
      const key = 'save_order_split';
      console.log('onSaveSplitCallback:', order_id, pid);
      message.loading({ content: '正在更新订单采购信息...', key });
      cancelGoodsSplitSpec(order_id, pid).then(() => {
        message.success({ content: `更新订单采购信息成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSplitSpecCallback = (id, pid, callback) => {
    try {
      const key = 'save_order_split';
      console.log('onSaveSplitCallback:', id, pid);
      message.loading({ content: '正在更新订单采购信息...', key });
      updateGoodsSplitSpec(id, pid).then(() => {
        message.success({ content: `更新订单采购信息成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onTerminateOrder = (id, no, callback) => {
    try {
      const key = 'save_order_split';
      console.log('onTerminateOrder:', id);
      message.loading({ content: '[' + no + ']正在终止订单...', key });
      terminateById(id).then(() => {
        reloadOrder();
        message.success({ content: `终止订单成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDraftOrder = (id, no, callback) => {
    try {
      const key = 'save_order_split';
      console.log('onTerminateOrder:', id);
      message.loading({ content: '[' + no + ']' + '订单正在另存为草稿...', key });
      draftById(id).then(() => {
        reloadOrder();
        message.success({ content: `订单另存为草稿成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onReviewPurchaseSuppliers = (order_id, params, callback) => {
    try {
      const key = 'review_purchase';
      console.log('onReviewPurchaseSuppliers:', order_id);
      message.loading({ content: '供应商审核中...', key });
      reviewPurchaseSuppliers(order_id, params).then(() => {
        message.success({ content: `供应商审核成功`, key, duration: 2 });
        callback && callback();
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onRestoreOrder = (id, no, callback) => {
    try {
      const key = 'save_order_split';
      console.log('onTerminateOrder:', id);
      message.loading({ content: '[' + no + ']订单正在恢复中...', key });
      restoreById(id).then(() => {
        reloadOrder();
        message.success({ content: `订单恢复成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onReturnOrderPackage = (id, supplier_id, delivery_date, callback) => {
    try {
      const key = 'sync_order_packages';
      console.log('onReturnOrderPackage:', id);
      message.loading({ content: '正在退回供应商数据...', key });
      returnOrderPackages(id, supplier_id, delivery_date).then(() => {
        reloadOrder();
        message.success({ content: `退回供应商数据成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onSyncOrderPackages = (id, callback) => {
    try {
      const key = 'sync_order_packages';
      console.log('onSyncOrderPackages:', id);
      message.loading({ content: '正在同步供应商数据...', key });
      syncOrderPackages(id).then(() => {
        reloadOrder();
        message.success({ content: `同步供应商数据成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSplitCountCallback = (id, pid, values, callback) => {
    try {
      const key = 'save_order_split';
      console.log('onSaveSplitCallback:', values);
      message.loading({ content: '正在更新订单采购信息...', key });
      updateGoodsSplitCount(id, pid, values).then(() => {
        message.success({ content: `更新订单采购信息成功`, key, duration: 2 });
        if (callback) {
          callback();
        }
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onSavePurchaseCallback = (id, values, callback) => {
    try {
      const key = 'save_order_purchase';
      console.log('onSavePurchaseCallback:', values);
      message.loading({ content: '正在更新订单采购信息...', key });
      savePurchaseByOrderId(id, values).then(() => {
        reloadOrder().then(() => {
          callback && callback();
          message.success({ content: `更新订单采购信息成功`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onNewCallback = async (value) => {
    try {
      const key = 'create_order';
      console.log('onNewCallback:', value);
      message.loading({ content: '正在新建订单...', key });
      insert(value).then(() => {
        reloadOrder().then(() => {
          setShowNew(false);
          message.success({ content: `新建订单成功 [#${value.order.po_code}]`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSaveCallback = async (value, callback) => {
    try {
      const key = 'create_order';
      message.loading({ content: '正在修改订单...', key });
      console.log('onSaveCallback:', value);
      update(value).then(() => {
        reloadOrder().then(() => {
          message.success({ content: `修改订单成功 [#${value.order.po_code}]`, key, duration: 2 });
        });
        callback && callback();
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const setPage = (page, pageSize) => {
    dispatch({ type: 'pagination', data: { limit: pageSize, offset: (page - 1) * pageSize } });
  }

  const setSelected = (selected) => {
    dispatch({ type: 'selected', data: selected });
  }

  const initialState = {
    suppliers: [],
    buyers: [],
    goods: [],
    total_rows: 0,
    rows: [],
    sort: { order: 'desc', sort: 'updated' },
    pagination: { limit: 10, offset: 0 },
    views: [],
    order_permission: []
  };
  function reducer(state, action) {
    switch (action.type) {
      case 'suppliers':
        return Object.assign({}, state, { suppliers: action.data });
      case 'order_goods': {
        const rows = state.rows;
        const o = rows.find(x => x.id === action.data.id);
        if (o) o.order_goods = action.data.data;
        return Object.assign({}, state, { rows: rows });
      }
      case 'order_permission':
        return Object.assign({}, state, { order_permission: action.data });
      case 'goods':
        return Object.assign({}, state, { goods: action.data });
      case 'buyers':
        return Object.assign({}, state, { buyers: action.data });
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      case 'total_rows':
        return Object.assign({}, state, { total_rows: action.data });
      case 'pagination':
        return Object.assign({}, state, { pagination: action.data });
      case 'selected': {
        const rows = state.rows;
        for (let i = 0; i < rows.length; i++) {
          if ((action.data || []).indexOf(i) > -1) {
            rows[i].selected = true;
          } else {
            rows[i].selected = false;
          }
        }
        return Object.assign({}, state, { rows: rows });
      }
      case 'new':
        return { total: state.total + 1 };
      case 'edit':
        return { total: state.total };
      case 'delete':
        return { total: state.total - 1 };
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const { suppliers } = state;

  const onClickOrderId = (id) => {
    setClickedOrderId(id);
    setShowDetail(true);
  }

  const reloadOrder = () => {
    var p1 = new Promise((resolve, reject) => {
      getListCount().then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getOrderList(state.pagination).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    return Promise.all([p1, p2]).then(values => {
      //setLoadding(false);
    });
  }

  useEffect(() => {
    var p1 = new Promise((resolve, reject) => {
      getSupplierList().then(data => {
        dispatch({ type: 'suppliers', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getOrderPermissionList('fm_order_permission').then(data =>
        dispatch({ type: 'order_permission', data: data }));
      resolve(true);
    });

    var p3 = new Promise((resolve, reject) => {
      getBuyerList().then(data => {
        dispatch({ type: 'buyers', data: data });
        resolve(true);
      });
    });

    var p4 = new Promise((resolve, reject) => {
      getGoodsList().then(data => {
        dispatch({ type: 'goods', data: data });
        resolve(true);
      });
    });

    Promise.all([p1, p2, p3, p4]).then(values => {
      //setLoadding(false);
    });
  }, [])

  useEffect(() => {
    setLoadding(true);
    var p1 = new Promise((resolve, reject) => {
      getListCount(keyword).then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getOrderList(state.pagination, undefined, keyword).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    Promise.all([p1, p2]).then(values => {
      setLoadding(false);
    });
  }, [state.pagination, keyword]);


  const afterClose = (e) => {

  }

  const Expandable = ({ props }) => {
    const { current } = props || {};
    return (
      <div style={{ margin: '-1px -1px 0 -1px', padding: '1rem 4rem', border: '1px solid #c0c0c0', backgroundColor: '#fcfcf0' }}>
        <Steps size="small" current={current} percent={60}>
          <Step title="新建订单  [张龙] " description="2020/10/03 14:03" />
          <Step title="采购 [赵虎]" subTitle="剩余13天14小时" description="双固紧固件公司" />
          <Step title="发货准备 [王朝]" description="新港仓库" />
          <Step title="发货 [马汉]" description="NEW YORK,NY" />
        </Steps>,
      </div>
    )
  }
  const { order_permission, rows, total_rows } = state;
  const onDownloadOrder = () => {
    const selectedOrders = rows.filter(x => x.selected === true);
    selectedOrders.forEach((o, i) => {
      downloadOrder(o);
    });
  }

  
  const downloadPackagePost = (order, no, supplier, rows) => {
    const body = parsePackageList(rows, {
      no: no.no,
      goods_code: no.goods_code || '',
      buyer_name: no.buyer_name_nick,
      po_code: no.po_code,
      sdate: no.date,
      supplier_name: no.supplier_name,
      delivery_date: no.delivery_date,
      remark: no.remark,
      pallet_flag: supplier.pallet_flag
    });
    const key = 'download';
    message.loading({ content: '正在生成装箱单...', key, duration: 20 });
    downloadDeliveryPost(order.id, no.id, body).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = '装箱单_' + order.po + '_' + no.no;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `装箱单下载成功`, key, duration: 2 });
      }
    });

  }

  const downloadOrderPackage = (order, no) => {
    const key = 'download';
    message.loading({ content: '正在生成装箱单...', key, duration: 20 });
    downloadPackage(order.id, no.id).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = '装箱单_' + order.po + '_' + no.no;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `装箱单下载成功`, key, duration: 2 });
      }
    });
  }

  const downloadOrderPalletDetail = (order, no) => {
    const key = 'download';
    message.loading({ content: '正在生成托盘明细...', key, duration: 20 });
    downloadPalletDetail(order.id, no.id).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = '托盘明细_' + order.po + '_' + no.no;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `托盘明细下载成功`, key, duration: 2 });
      }
    });
  }

  const downloadOrderPurchase = (order, date, type) => {
    const key = 'download';
    message.loading({ content: '正在生成供应商采购合同...', key, duration: 20 });
    downloadPurchase(order.id, date, type).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = '采购合同_' + order.po + '_' + order.no;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `供应商采购合同下载成功`, key, duration: 2 });
      }
    });
  }

  const downloadOrder = (order, type) => {
    const key = 'download';
    message.loading({ content: '正在生成客户回单...', key, duration: 20 });
    download(order.id, type).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = '客户回单_' + order.po + '_' + order.no;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `客户回单下载成功`, key, duration: 2 });
      }
    });
  }

  const showRestoreConfirm = () => {
    const selectedOrders = rows.filter(x => x.selected === true);
    const msg = selectedOrders.map((o, i) => {
      return <span>{o.no} (#{o.po_code})<br /></span>
    });
    Modal.confirm({
      title: '确定恢复当前订单吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{msg}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        selectedOrders.forEach(x => {
          onRestoreOrder(x.id, x.no)
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const showDraftConfirm = () => {
    const selectedOrders = rows.filter(x => x.selected === true);
    const msg = selectedOrders.map((o, i) => {
      return <span>{o.no} (#{o.po_code})<br /></span>
    });
    Modal.confirm({
      title: '确定将当前订单转为草稿吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{msg}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        selectedOrders.forEach(x => {
          onDraftOrder(x.id, x.no);
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const showTerminateConfirm = () => {
    const selectedOrders = rows.filter(x => x.selected === true);
    const msg = selectedOrders.map((o, i) => {
      return <span>{o.no} (#{o.po_code})<br /></span>
    });
    Modal.confirm({
      title: '确定终止当前订单吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{msg}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        selectedOrders.forEach(x => {
          onTerminateOrder(x.id, x.no)
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const optionMenu = [];
  if (rows.filter(x => x.selected === true && x.status === 0).length === 0) {
    optionMenu.push(<div>
      <Button onClick={showRestoreConfirm} type="primary" icon={<CheckCircleOutlined />}>
        <span style={{ padding: '0 1rem' }}>恢复订单</span>
      </Button>
    </div>);
  }

  if (rows.filter(x => x.selected === true && (x.status > 0 || x.delivery_ok_percent >= 0.99999)).length === 0) {
    optionMenu.push(<div>
      <Button onClick={showDraftConfirm} icon={<FormOutlined />}>
        <span style={{ padding: '0 1rem' }}>转为草稿</span>
      </Button>
    </div>);
    optionMenu.push(
      <div>
        <Button onClick={showTerminateConfirm} type="danger" icon={<DeleteOutlined />}>
          <span style={{ padding: '0 1rem' }}>终止订单</span>
        </Button>
      </div>);
  }
  /*     <div>
        <Button onClick={onDownloadOrder} style={{ backgroundColor: '#f0f0f0f' }} type="primary" icon={<DownloadOutlined />} >
          <span style={{ padding: '0 1rem' }}>下载客户回单</span>
        </Button>
      </div> */


  const clickedOrder = rows.find(x => x.id === clickedOrderId);
  return (
    <OrderContext.Provider value={state}>
      <div style={{ padding: '0.5rem 1.5rem' }}  >
        <Table
          showFilter={true}
          onSearch={onSearch}
          onSearchPlaceHolder="请输入NO或PO或客户名称"
          setSelectedCallback={setSelected}
          setPageCallback={setPage}
          isLoadding={isLoadding}
          optionMenu={optionMenu}
          expandable={false}
          hasCheckbox={true}
          title="销售订单管理"
          newLabel={"新建销售订单"}
          showNewLabel={authorities.find(x => x === 'create_order') || currentUser.category_id === 1}
          showFooter={true}
          rows={rows}
          total_rows={total_rows}
          onNew={() => setShowNew(!isShowNew)}
          header={[
            {
              label: 'PO编码', width: '120px', item: 'po_code', align: 'center', sortable: true, render: (text, row, index) => {
                if (row.status === 2) return <Button type="link" onClick={() => onClickOrderId(row.id)} style={{ padding: 0 }} size="small">{text}</Button>;
                else {
                  return <div>
                    <Button type="link" onClick={() => onClickOrderId(row.id)} style={{ padding: 0 }} size="small">{text}</Button>
                    {!row.supplier_ids && <Badge style={{ paddingLeft: '0.5rem' }} status="processing" />}
                  </div>;
                }
              }
            },
            {
              label: '订单编号', width: '120px', align: 'center', item: 'no', sortable: 'true'
            },
            {
              label: '客户代号', width: '120px', align: 'center', item: 'buyer_name_nick', sortable: 'true',
              render: (text, row, index) => {
                if (row.status === 2) return undefined;
                if (!row.delivery_date)
                  return <div><Button style={{ padding: 0 }} type='text' size='small'>{text}</Button></div>
                else return <div>{text}</div>
              }
            },
            {
              label: '金额', item: 'amount', width: '140px', align: 'right', render:
                (text, row, index) => {
                  if (row.status === 2) return undefined;
                  if (text) return <div>{row.currency_symbol}{text.toFixed(2)}</div>
                  else return null;
                }
            },
            {
              label: '客户交付期限', width: '160px', item: 'delivery_deadline_date',
              render: (text, row, index) => {
                if (row.status === 2) return undefined;
                if (row.delivery_ok_percent >= 0.99999) {
                  return text;
                }
                //if (row.date_left < 15 && row.date_left > 7 && !row.delivery_date) {
                //  return <div>{text}<Tag style={{ marginLeft: '0.25rem', padding: '0 0.25rem' }} size="small" color="#FF8C00">{row.date_left}天</Tag></div>
                //} else 
                if (row.date_left <= 15 && !row.delivery_date) {
                  return <div>{text}<Tag style={{ marginLeft: '0.25rem', padding: '0 0.25rem' }} size="small" color="#F50">{row.date_left}天</Tag></div>
                } else return <div>{text}</div>
              }
            },

            {
              label: '工厂交付日期', width: '160px', item: 'delivery_deadline_date',
              render: (text, row, index) => {
                if (row.status === 2) return undefined;
                const before15 = moment(row.delivery_deadline_date).add(-15, 'days').format('YYYY-MM-DD');
                if (row.delivery_ok_percent >= 0.99999) {
                  return before15;
                }
                if (row.date_left < 30 && !row.delivery_date) {
                  return <div>{before15}<Tag style={{ marginLeft: '0.25rem', padding: '0 0.25rem' }} size="small" color="#FF8C00">{row.date_left - 15}天</Tag></div>
                } //else if (row.date_left <= 22 && !row.delivery_date) {
                //return <div>{before15}<Tag style={{ marginLeft: '0.25rem', padding: '0 0.25rem' }} size="small" color="#F50">{row.date_left - 15}天</Tag></div>
                //}
                else return <div>{before15}</div>
                /* const dates = row.plan_delivery_date || [];
                if (dates.length > 1) {
                  return <Tooltip
                    title={
                      <div style={{ padding: '0 1rem' }}>
                        {dates.map(d => {
                          return <span>{d}<br /></span>
                        })}
                      </div>
                    }>
                    <Button style={{ padding: 0 }} type="text" size="small">{dates[0]} ..({dates.length})</Button>
                  </Tooltip>
                } else if (dates.length === 1) {
                  return <div>{dates[0]}</div>
                } */
              }
            },
            // {
            //   label: '供应商', width: '140px', item: 'supplier_ids', render:
            //     (text, row, index) => {
            //       if (!text || row.status === 2) return null;
            //       const ids = text.split(',');
            //       const names = ids.map(id => ((suppliers.find(x => x.id === parseInt(id)) || {}).name));
            //       if (ids.length > 1) {
            //         return <Tooltip
            //           title={
            //             <div style={{ padding: '0 1rem' }}>
            //               {names.map(name => {
            //                 return <span>{name}<br /></span>
            //               })}
            //             </div>
            //           }>
            //           {
            //             row.delivery_date && <Button style={{ padding: 0 }} type="text" size="small">{names[0]} ..({names.length})</Button>
            //           }
            //           {
            //             !row.delivery_date && <Button style={{ padding: 0 }} type="text" size="small">{names[0]} ..({names.length})</Button>
            //           }
            //         </Tooltip>
            //       } else {
            //         if (!row.delivery_date) {
            //           return <Button style={{ padding: 0 }} type="text" size="small">{names[0]}</Button>
            //         } else
            //           return <div>{text}</div>
            //       }
            //     }
            // },
            {
              label: '订单-发货-交付状态', width: '210px', item: 'status', render: (text, row, index) => {
                if (text === 1) {
                  return <div style={{ textAlign: 'center', color: 'red' }}>[已终止]</div>
                } else if (text === 2) {
                  return <div style={{ textAlign: 'center', color: 'red' }}>[草稿版本]</div>
                }
                if (!row.order_goods_count || !row.order_goods_purchase_count) return undefined;
                const p = 100 - Math.floor(row.ok_percent * 1000) / 10;
                const sp = 100 - Math.floor(row.delivery_ok_percent * 1000) / 10;
                return <Tooltip
                  title={
                    <div style={{ padding: '0 1rem' }}>
                      订单数量：{row.order_goods_count} 件<br />
                        采购数量：{row.order_goods_purchase_count} 件 <span style={{ color: 'yellow' }}>(补箱:{row.order_goods_purchase_count - row.order_goods_count})</span><br />
                      <span>-------------------------------</span><br />
                        已发数量：{row.delivery_ok_real} 件<br />
                        待发数量：{row.ok_real - row.delivery_ok_real} 件<br />
                        剩余数量：{row.order_goods_purchase_count - row.ok_real} 件
                    </div>
                  }>
                  {
                    row.delivery_ok_percent >= 0.99999 && <div style={{ textAlign: 'center', color: 'green' }}>[已完成]</div>
                  }
                  {
                    row.delivery_ok_percent < 0.99999 && <Progress
                      style={{ padding: '0 0.5rem 0 0' }}
                      trailColor="#c0c0c0"
                      success={{ strokeColor: '#0p0ff00', percent: p - 0.01 }}
                      percent={sp + p} />
                  }
                </Tooltip>
              }
            },
            {
              label: '对接业务员', width: '120px', item: 'owner_id', align: 'center', render: (text, row, index) => {
                return <div>{user.find(x => x.id === text).name}</div>
              }
            },
            {
              label: '备注', width: '215px', item: 'remark', render: (text, row, index) => {
                return <span>{text}</span>
              }
            }
          ]}
          bordered={true} />
        <Page
          title="新建订单"
          width="1080px"
          isMaximize={true}
          onCloseCallback={() => setShowNew(!isShowNew)}
          afterClose={afterClose}
          body={<OrderNew
            onSaveCallback={onNewCallback}
            setShowGoodsSelect={setShowGoodsSelect}
            onCloseCallback={() => setShowNew(false)}
            orderGoods={[]}
            mode="new" />}
          visible={isShowNew}
        />
        <Page
          title={`订单详细 [ ${clickedOrder && '#' + clickedOrder.po_code} ]`}
          width="1080px"
          isMaximize={true}
          onCloseCallback={() => setShowDetail(!isShowDetail)}
          body={<OrderDetail
            reloadOrder={reloadOrder}
            downloadOrder={downloadOrder}
            downloadPurchase={downloadOrderPurchase}
            downloadPackage={downloadOrderPackage}
            downloadPackagePost={downloadPackagePost}
            downloadPalletDetail={downloadOrderPalletDetail}
            onCancelSplitCountCallback={onCancelSplitCountCallback}
            onSplitSpecCallback={onSplitSpecCallback}
            onCancelSplitSpecCallback={onCancelSplitSpecCallback}
            onSplitCountCallback={onSplitCountCallback}
            onSaveCallback={onSaveCallback}
            onSyncOrderPackages={onSyncOrderPackages}
            onReturnOrderPackage={onReturnOrderPackage}
            onSavePermissionCallback={onSavePermissionCallback}
            onSavePurchaseCallback={onSavePurchaseCallback}
            onReviewPurchaseSuppliersCallback={onReviewPurchaseSuppliers}
            order={clickedOrder}
            onCloseCallback={() => setShowDetail(false)}
            setShowGoodsSelect={setShowGoodsSelect} />}
          visible={isShowDetail} />
      </div>
      <Page
        title="产品选择"
        width="1024px"
        onCloseCallback={() => setShowGoodsSelect(!isShowGoodsSelect)}
        afterClose={afterClose}
        body={<GoodsSelect />}
        visible={isShowGoodsSelect}
      />
    </OrderContext.Provider>
  );
});
